module.exports = __webpack_public_path__ + "static/media/img_tree_with_sky.7721341c.png";